import { render, staticRenderFns } from "./modifyAbout.vue?vue&type=template&id=ca9af072&scoped=true"
import script from "./modifyAbout.vue?vue&type=script&lang=js"
export * from "./modifyAbout.vue?vue&type=script&lang=js"
import style0 from "./modifyAbout.vue?vue&type=style&index=0&id=ca9af072&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9af072",
  null
  
)

export default component.exports